module.exports = __webpack_public_path__ + "static/media/logo-brand.4ee10cf1.png";